<template>
	<div class="MasterCategoriesList">
		<MasterCategoriesItem
			class="order-item-details"
			v-for="(item, index) in list"
			:key="index"
			:item="item"
			@click.native="selectItem(item)"
		/>
	</div>
</template>

<script>
import MasterCategoriesItem from './MasterCategoriesItem.vue'

export default {
	props: [
		'list',
		'selectItem',
	],

	components: {
		MasterCategoriesItem,
	},
}
</script>

<style lang="scss" scoped>
	.MasterCategoriesList {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}
</style>
